import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useModals } from '../../PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider'

import {
  formatCurrency,
  formatDateTime,
  getTimezoneDate,
  timezones,
} from '../../../utilities/helpers'
import { flexPackDisplayPrice } from '../../../utilities/flexPackPrice'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { DetailsButton } from '../../DetailsButton'
import { FlexPackNumVouchersBadge } from '../../FlexPackNumVouchersBadge'

import './lists.scss'

export default function FlexPacksList({ venue, flexPacks }) {
  const navigate = useNavigate()

  const timezone = timezones(venue?.timezone)

  const { openModal } = useModals()

  const handleOpen = (desc) => {
    openModal('Description', desc)
  }

  return (
    <>
      {flexPacks?.length > 0 ? (
        <Stack as="ul">
          <>
            {flexPacks.map((flexPack, idx) => (
              <Card body as="li" key={idx} className="item card-xs card--light">
                <Stack
                  gap={2}
                  className="flex-md-row gap-md-3 justify-content-md-between"
                >
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="image-event-info-wrapper"
                  >
                    <Card.Img
                      src={flexPack?.image?.url}
                      alt={`Cover art for ${flexPack?.name} flex pack`}
                      width="100"
                      height="100"
                      className="event-image"
                    />
                    <div className="event-info">
                      <div className="event-name-date-wrapper">
                        <p className="event-name m-0">{flexPack?.name}</p>
                        <p className="small">
                          {flexPack?.organization?.name} -{' '}
                          {flexPack?.season?.name}
                        </p>
                      </div>
                      <div className="tablet-desktop-only">
                        <span className="event-date">
                          <span>
                            {formatDateTime(
                              getTimezoneDate(flexPack.start, timezone),
                              'dateOnly'
                            )}
                          </span>
                          <span className="to">
                            <span>
                              {formatDateTime(
                                getTimezoneDate(flexPack?.end, timezone),
                                'dateOnly'
                              )}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </Stack>
                  <div className="mobile-only">
                    <span className="event-date">
                      <span>
                        {formatDateTime(
                          getTimezoneDate(flexPack.start, timezone),
                          'dateOnly'
                        )}
                      </span>
                      <span className="to">
                        <span>
                          {formatDateTime(
                            getTimezoneDate(flexPack?.end, timezone),
                            'dateOnly'
                          )}
                        </span>
                      </span>
                    </span>
                  </div>
                  <div className="btn-flex-group">
                    {flexPack?.description && (
                      <DetailsButton
                        onClick={(e) => handleOpen(flexPack?.description)}
                      />
                    )}
                    <FlexPackNumVouchersBadge tickets={flexPack?.gameTickets} />
                    <Button
                      className="mt-0"
                      onClick={() => navigate(`flex-pack/${flexPack?.uuid}`)}
                    >
                      From {formatCurrency(flexPackDisplayPrice(flexPack))}
                    </Button>
                  </div>
                </Stack>
              </Card>
            ))}
          </>
        </Stack>
      ) : (
        <Stack className="align-items-center">
          <h1 className="fs-md">No Flex Packs</h1>
          <p className="subtitle">This venue has no flex packs</p>
        </Stack>
      )}
      {/* <LoadingContainer /> */}
    </>
  )
}
